import React from 'react';

import useSearchWidget from '../../../hooks/useSearchWidget';

import SearchBlockUI from './../../../../stories/components/hotels/HomePage/SearchBlockUI/SearchBlockUI';

const SearchBlock = () => {

  const {
    checkin,
    checkout,
    roomString,
    destination,
    country,
    partner,
    updateQueryCaller,
    autosuggestHandler,
  } = useSearchWidget();


  return (
    <SearchBlockUI
      country={country}
      checkin={checkin}
      checkout={checkout}
      roomString={roomString}
      destination={destination}
      partner={partner}
      updateQueryCaller={updateQueryCaller}
      autosuggestHandler={autosuggestHandler}
    />
  );
};

export default SearchBlock;
